// Pedido do André (20/09): abre o popup de "opção extra" (ex.: deseja bojo?)
// automaticamente na primeira vez que o cliente muda uma variante (tamanho,
// cor) na página do produto, em vez de deixar a pergunta sempre visível
// ocupando espaço. O popup só abre uma vez por visita à página.
(function () {
  var opened = false;

  function openFirstAsk() {
    if (opened) return;
    var ask = document.querySelector('[data-hoad-quick-ask]');
    if (!ask) return;
    opened = true;
    ask.classList.add('is-open');
  }

  document.addEventListener('product:variant-change', openFirstAsk);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-hoad-quick-ask-dismiss]')) {
      var ask = event.target.closest('[data-hoad-quick-ask]');
      if (ask) ask.classList.remove('is-open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-hoad-quick-ask].is-open').forEach(function (ask) {
        ask.classList.remove('is-open');
      });
    }
  });
})();
